'use client'

import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface ProfileModalContextType {
    showProfile: boolean;
    openProfile: () => void;
    handleProfileHide: () => void;
}

const ProfileModalContext = createContext<ProfileModalContextType | undefined>(undefined);

export function ProfileModalProvider({ children }: { children: ReactNode }) {
    const [showProfile, setShowProfile] = useState(false);

    useEffect(() => {
        const checkProfileParam = () => {
            const urlParams = new URLSearchParams(window.location.search);
            const profileParam = urlParams.get('profile');
            setShowProfile(profileParam === 'true');
        };

        checkProfileParam();
        window.addEventListener('popstate', checkProfileParam);
        return () => window.removeEventListener('popstate', checkProfileParam);
    }, []);

    const openProfile = () => {
        const url = new URL(window.location.href);
        url.searchParams.set('profile', 'true');
        window.history.pushState({}, '', url);
        setShowProfile(true);
    };

    const handleProfileHide = () => {
        setShowProfile(false);
        const url = new URL(window.location.href);
        url.searchParams.delete('profile');
        window.history.pushState({}, '', url);
    };

    return (
        <ProfileModalContext.Provider value={{ showProfile, openProfile, handleProfileHide }}>
            {children}
        </ProfileModalContext.Provider>
    );
}

export function useProfileModal() {
    const context = useContext(ProfileModalContext);
    if (context === undefined) {
        throw new Error('useProfileModal must be used within a ProfileModalProvider');
    }
    return context;
}
